import { useSelector } from 'react-redux';
import type { OrderCreateState } from '../dashboard/components/FSO/types';
import { RulesState } from '../dashboard/components/Rules/types';
import { BatchesState } from '../store/states/batchesState';
import { CommonState } from '../store/states/commonState';
import { InvoiceSettingsStoreState } from '../store/states/invoiceSettingsState';

interface IState extends Record<string, any> {
  batches: BatchesState;
  rules: RulesState;
  invoiceSettings: InvoiceSettingsStoreState;
  orderCreate: OrderCreateState;
}

export const useCannabisBatchState = () =>
  useSelector<IState>((state) => {
    const cannabisBatch = { ...state.cannabisBatch };

    const dateFields = [
      'expirationDate',
      'harvestDate',
      'labResultsDate',
      'manufactureDate',
    ];

    dateFields.forEach((field) => {
      if (cannabisBatch[field] && typeof cannabisBatch[field] === 'number') {
        cannabisBatch[field] = new Date(cannabisBatch[field]);
      }
    });

    return cannabisBatch;
  });
export const useBrandPagesState = () =>
  useSelector<IState>((state) => state.brandPages);
export const useWebhookDashboardState = () =>
  useSelector<IState>((state) => state.webhookDashboard);
export const useDispensaryDashboardState = () =>
  useSelector<IState>((state) => state.dispensaryDashboard);
export const useOrderCreateState = (): OrderCreateState =>
  useSelector<IState, OrderCreateState>((state) => state.orderCreate);
export const useStorefrontState = () =>
  useSelector<IState>((state) => state.storefront);
export const useProductsState = () =>
  useSelector<IState>((state) => state.products);
export const useBatchesState = () =>
  useSelector<IState, BatchesState>((state) => state.batches);
export const useUserState = () => useSelector<IState>((state) => state.user);
export const useVendorBrandsState = () =>
  useSelector<IState>((state) => state.vendorBrands);
export const useInventoryPricingState = () =>
  useSelector<IState>((state) => state.inventoryPricing);
export const useQuickbooksState = (): any =>
  useSelector<IState>((state) => state.quickbooks);
export const useCommonState = () =>
  useSelector<IState, CommonState>((state) => state.common);
export const useRulesState = (): RulesState =>
  useSelector<IState, RulesState>((state) => state.rules);
export const useInvoiceSettingsState = (): InvoiceSettingsStoreState =>
  useSelector<IState, InvoiceSettingsStoreState>(
    (state) => state.invoiceSettings
  );
